import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppTheme, useAppTheme } from 'common/theme';

/**
 * @private
 */
const baseline = 8;

export const avatarSize = baseline * 6.5; // 52
export const containerWidth = baseline * 11; // 88
export const containerHeight = baseline * 13.5; // 108

const getStyles = memoizeFunction((theme: IAppTheme, width?: number, height?: number) => {
  return mergeStyleSets({
    container: {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      width: containerWidth,
      paddingTop: baseline,
    },
    fadedImage: {
      opacity: 0.5,
    },
    icon: {
      bottom: '-2px',
      position: 'absolute',
      right: '-2px',
    },
    imageStyles: {
      borderRadius: '100%',
      height: height ?? avatarSize,
      width: width ?? avatarSize,
      // avoid showing an empty space if
      // image src load time exceeds loading state:
      backgroundColor: theme.appColors?.slate100,
    },
    imageWrapper: {
      flexShrink: 0,
      height: avatarSize,
      position: 'relative',
      width: avatarSize,
    },
    textStyles: {
      marginTop: baseline,
      textAlign: 'center',
      width: containerWidth,
      maxWidth: '15ch',
    },
  });
});

export const useAvatarStyles = (width?: number, height?: number) => {
  const theme = useAppTheme();
  return getStyles(theme, width, height);
};
